
import { defineComponent } from "vue";

export default defineComponent({
  name: "DeleteExercisesModal",
  props: ["selectedExercises"],
});
